import { DELETE_AGENT_LOG } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface DeleteAgentLogResponse {
  success: boolean;
  message?: string;
}

type DeleteAgentLogPayload = {
  logId: string;
};

const deleteAgentLog = async (
  payload: DeleteAgentLogPayload
): Promise<DeleteAgentLogResponse> => {
  try {
    const response = await makeAuthenticatedRequest(DELETE_AGENT_LOG, {
      method: 'DELETE',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { deleteAgentLog, type DeleteAgentLogPayload, type DeleteAgentLogResponse };
